// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatingButton-module_root_Thf_-","main":"FloatingButton-module_main_dAAlA"};